import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface Coords { lat: number; lon: number; }

@Injectable({ providedIn: 'root' })
export class GeolocationService {
  private readonly storageKey = 'userCoords';
  private readonly maxAgeMs = 10 * 60 * 1000; // 10 minutes

  getCoords(forceFresh = false): Observable<Coords | null> {
    return new Observable<Coords | null>((observer) => {
      if (!forceFresh) {
        const cached = this.getCached();
        if (cached) {
          observer.next(cached);
          observer.complete();
          return;
        }
      }

      if (!('geolocation' in navigator)) {
        observer.next(null);
        observer.complete();
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const coords: Coords = { lat: pos.coords.latitude, lon: pos.coords.longitude };
          try { localStorage.setItem(this.storageKey, JSON.stringify({ t: Date.now(), coords })); } catch {}
          observer.next(coords);
          observer.complete();
        },
        () => {
          observer.next(null);
          observer.complete();
        },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: this.maxAgeMs }
      );
    });
  }

  private getCached(): Coords | null {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return null;
      const { t, coords } = JSON.parse(raw);
      if (!t || !coords) return null;
      if (Date.now() - t > this.maxAgeMs) return null;
      return coords as Coords;
    } catch { return null; }
  }
}
